import React from 'react';
import { Chip, styled, Tooltip } from '@mui/material';
import Icon from '@mdi/react';

import { useAppDispatch } from '../../state/hooks';
import { openFilterPanel } from '../../state/features/filterSlice';

const classesPrefix = 'activeFilterChip';

const classes = {
    root: `${classesPrefix}-root`,
    icon: `${classesPrefix}-icon`,
    clickable: `${classesPrefix}-clickable`,
};

const StyledChip = styled(Chip)(({ theme }) => {
    return {
        [`&.${classes.root}`]: {
            backgroundColor: 'transparent',
            color: theme.palette.getContrastText(
                theme.palette.primary.main
            ),
            transitionProperty: 'color, background-color, box-shadow',
        },
        [`& .${classes.icon}`]: {
            color: theme.palette.warning.dark,
        },
        [`&.${classes.clickable}`]: {
            border: 'solid 1px transparent',
            '&:hover': {
                backgroundColor: theme.palette.common.white,
                color: theme.palette.primary.main,
            },
            '&:focus': {
                backgroundColor: theme.palette.common.white,
                color: theme.palette.primary.main,
            },
        },
    };
});

const ActiveFilterChip = ({
    tooltip,
    label,
    icon,
    isClickable = true,
}: {
    tooltip: string;
    label: string;
    icon: string;
    isClickable?: boolean;
}): React.JSX.Element => {
    const dispatch = useAppDispatch();

    return (
        <Tooltip title={tooltip} placement='top'>
            <StyledChip
                classes={{
                    root: classes.root,
                    icon: classes.icon,
                    ...isClickable && { clickable: classes.clickable },
                }}
                icon={<Icon path={icon} size={1} />}
                label={label}
                onClick={
                    isClickable ?
                        (): void => {
                            dispatch(openFilterPanel());
                        } : undefined
                }
            />
        </Tooltip>
    );
};

export default ActiveFilterChip;
